import { NotionEditor } from '@/features/instructions/components/NotionEditor'

interface Props {
  title: string
  onTitleChange: (s: string) => void
  content: string
  onContentChange: (s: string) => void
  titlePlaceholder: string
  contentPlaceholder: string
  disabled: boolean
}

const autoGrow = (el: HTMLTextAreaElement | null) => {
  if (!el) return
  el.style.height = 'auto'
  el.style.height = el.scrollHeight + 'px'
}

export const ContentTab = ({
  title,
  onTitleChange,
  content,
  onContentChange,
  titlePlaceholder,
  contentPlaceholder,
  disabled,
}: Props) => (
  <div>
    <textarea
      value={title}
      onChange={(e) => onTitleChange(e.target.value)}
      placeholder={titlePlaceholder}
      rows={1}
      disabled={disabled}
      onInput={(e) => autoGrow(e.currentTarget)}
      ref={autoGrow}
      className="w-full text-3xl font-bold bg-transparent border-none outline-none placeholder:text-muted-foreground/50 text-foreground mb-6 resize-none overflow-hidden leading-tight break-words"
    />
    <NotionEditor
      value={content}
      onChange={onContentChange}
      placeholder={contentPlaceholder}
      editable={!disabled}
    />
  </div>
)
